import { render } from "./TagUpdateModal.vue?vue&type=template&id=6d267364&scoped=true&ts=true"
import script from "./TagUpdateModal.vue?vue&type=script&lang=ts"
export * from "./TagUpdateModal.vue?vue&type=script&lang=ts"

import "./TagUpdateModal.vue?vue&type=style&index=0&id=6d267364&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d267364"]])

export default __exports__